<template>
    <v-container fluid class="wave">
        <v-row class="sea-background" style="background-color: #232323;" justify="center" align="center">
            <!-- <v-col cols="1">
                <v-img contain height="40px" :src="require('@/assets/palm.png')" style="z-index: 1000;" />
            </v-col>
            <v-col cols="1">
                <v-img contain height="40px" :src="require('@/assets/flamingo.png')" style="z-index: 1000;" />
            </v-col> -->
            <div class="white--text" style="font-size: 30px;">
                Sponsors & Partners
            </div>
            <v-col cols="12" align="center">
                <v-row>
                    <v-col cols="3" md="4">
                        <div class="secondary-font">Official EKA League Appearance</div>
                        <img
                            height="150px"
                            width="auto"
                            :src="require('@/assets/gsa.jpg')"
                            style="cursor: pointer;"
                            class="mb-5"
                            @click="openSocial('gsa')"
                        >
                    </v-col>
                    <v-col cols="3" md="4">
                        <div class="secondary-font">Official EKA League Ball</div>
                        <img
                            height="150px"
                            width="auto"
                            :src="require('@/assets/molten.png')"
                            style="cursor: pointer;"
                            class="mb-5"
                            @click="openSocial('molten')"
                        >
                    </v-col>
                    <v-col cols="3" md="4">
                        <div class="secondary-font">Official sponsor </div>
                        <img
                            height="120px"
                            width="auto"
                            :src="require('@/assets/e-academy.png')"
                            style="cursor: pointer;"
                            class="mb-5"
                            @click="openSocial('e-academy')"
                        >
                    </v-col>
                    <v-col cols="3" md="4">
                        <div class="secondary-font">Powered by</div>
                        <img
                            height="115px"
                            width="auto"
                            :src="require('@/assets/sportsiq.jpg')"
                            style="cursor: pointer;"
                            @click="openSocial('sportsiq')"
                        >
                    </v-col>
                </v-row>
            </v-col>
            <div class="white--text mx-3" style="font-size: 30px;">follow us on social</div>
            <v-col cols="12" align="center">
                <img height="50px" width="auto" :src="require('@/assets/facebook.png')" class="custom-teal-text" @click="openSocial('facebook')">
                <img height="50px" width="auto" :src="require('@/assets/instagram.png')" class="custom-teal-text mx-5" @click="openSocial('instagram')">
                <img height="50px" width="auto" :src="require('@/assets/youtube.png')" class="custom-teal-text mr-5" @click="openSocial('youtube')">
                <img height="50px" width="auto" :src="require('@/assets/twitter.png')" class="custom-teal-text mr-5" @click="openSocial('twitter')">
                <img height="50px" width="auto" :src="require('@/assets/linkedin.png')" class="custom-teal-text mr-5" @click="openSocial('linkedin')">
                <!-- <v-img
                    :width="!$vuetify.breakpoint.mobile ? '20px' : '20px'"
                    contain
                    style="display: inline-flex; cursor: pointer;"
                    :src="require('@/assets/tiktok-gradient.svg')"
                    @click="openSocial('tiktok')"
                /> -->
                <!-- <v-img
                    height="53px"
                    width="180px"
                    class="mx-2"
                    style="display: inline-flex; cursor: pointer;"
                    :src="require('@/assets/google_play.png')"
                    @click="openSocial('google_play')"
                />
                <v-img
                    height="53px"
                    width="160px"
                    class="mx-2"
                    style="display: inline-flex; cursor: pointer;"
                    :src="require('@/assets/app_store.svg')"
                    @click="openSocial('app_store')"
                /> -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        methods: {
            openSocial(social) {
                if (social === 'facebook') {
                    window.open('https://www.facebook.com/eka.league.gr', '_blank')
                } else if (social === 'instagram') {
                    window.open('https://www.instagram.com/eka_league.gr/', '_blank')
                } else if (social === 'youtube') {
                    window.open('https://www.youtube.com/channel/UC5hvrVJnTvrSrcf970QpqNg', '_blank')
                } else if (social === 'tiktok') {
                    window.open('', '_blank')
                } else if (social === 'twitter') {
                    window.open('https://x.com/eka_league', '_blank')
                } else if (social === 'linkedin') {
                    window.open('https://www.linkedin.com/company/eka-league/', '_blank')
                } else if (social === 'gsa') {
                    window.open('https://www.gsasport.com/gr/', '_blank')
                } else if (social === 'google_play') {
                    window.open('https://play.google.com/store/apps/details?id=com.vue.big.app', '_blank')
                } else if (social === 'app_store') {
                    window.open('https://apps.apple.com/us/app/b-i-g/id6748522198', '_blank')
                } else if (social === 'e-academy') {
                    window.open('https://eacademy.gr/', '_blank')
                }
            }
        }
    }
</script>

<style scoped>
.custom-divider {
    border-color: teal;
    border-width: 1px;
    height: 20px;
    margin: 0 10px 0 10px;
    display: inline-flex;
    min-height: 100%;
    max-height: 100%;
    vertical-align: text-bottom;
}

/*
.sea-background {
    background-color: #91dcef;
}

.wave {
    display: block;
    position: relative;
    height: 50px;
    width: 100%;
    background: #f2d16b;
    transform: scale(1, 1);
}

.wave::before {
    content: "";
    display: block;
    position: absolute;
    border-radius: 100%;
    width: 100%;
    height: 300px;
    background-color: #f2d16b;
    right: -25%;
    top: 20px;
}

.wave::after {
    content: "";
    display: block;
    position: absolute;
    border-radius: 100%;
    width: 100%;
    height: 310px;
    background-color: #f2d16b;
    left: -25%;
    top: -240px;
    clip-path: ellipse(100% 15% at -15% 100%);
} */
</style>
